module.exports = __webpack_public_path__ + "img/methodology_b.8d1b8275.png";